'use client'
import styled from 'styled-components'
import { getStyledButtonStyles } from './style'
import { StyledButtonProps } from './type'

const StyledButton = styled.button.withConfig({
    shouldForwardProp: (prop) =>
        ![
            'backgroundColor',
            'borderStyle',
            'height',
            'minWidth',
            'maxWidth',
            'paddingTop',
            'paddingBottom',
            'borderColor',
            'borderWidth',
            'cursor',
            'color'
        ].includes(prop)
})<StyledButtonProps>(
    ({
        backgroundColor,
        borderStyle,
        height,
        minWidth,
        maxWidth,
        paddingTop,
        paddingBottom,
        borderColor,
        borderWidth,
        cursor,
        theme
    }) =>
        getStyledButtonStyles({
            backgroundColor,
            borderStyle,
            height,
            minWidth,
            maxWidth,
            paddingTop,
            paddingBottom,
            borderColor,
            borderWidth,
            cursor,
            theme
        })
)

export default StyledButton
